import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateLinks, BackToModuleButton } from '@/components';
import { fleetPageBreadcrumbs } from '../../../config/breadcrumbs';
import NewCompanyForm from '../../components/NewCompanyForm';

const NewCompany = () => {
  
  const navigate = useNavigate();

  const breadcrumbs = useMemo<NavigateLink[]>(() => {
    const base = fleetPageBreadcrumbs(navigate);
    return [
      ...base,
      { label: 'Compañías', onClick: () => navigate('/fleet/companies') },
    ];
  }, [navigate]);

  return (
    <section className="flex h-full w-full flex-col gap-[25px]">
      <NavigateLinks actualPage="Agregar compañía" breadcrumbs={breadcrumbs} />
      <div className="flex justify-end gap-5">
        <BackToModuleButton breadcrumbs={breadcrumbs} />
      </div>
      <div className="w-[800px] mx-auto mt-8 flex rounded-[5px] shadow-[0_0_4px_rgba(0,0,0,0.1)]">
        <NewCompanyForm />
      </div>
    </section>
  );
};

export default NewCompany;
